import type { CustomersProduct } from '@/models/customersTypes';

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

const parseDate = (value?: string | null, boundary: 'start' | 'end' = 'start'): Date | null => {
  if (!value) return null;
  const trimmed = value.trim();

  if (DATE_ONLY_REGEX.test(trimmed)) {
    const [year, month, day] = trimmed.split('-').map(Number);
    if (boundary === 'end') {
      return new Date(year, month - 1, day, 23, 59, 59, 999);
    }
    return new Date(year, month - 1, day, 0, 0, 0, 0);
  }

  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const isDiscountActive = (product: CustomersProduct, now = new Date()): boolean => {
  if (!product.reduced_price) return false;

  const endDate = parseDate(product.discount_end_date, 'end');

  if (endDate && now > endDate) return false;

  return true;
};
